import Vue from 'vue'
import Vuex from 'vuex'
import AppModule from './app/'
import AppCategories from './category/'
import User from './user/'
import Utils from './util/'

Vue.use(Vuex);
  
const store = new Vuex.Store({
    modules: {
        apps: AppModule,
        category: AppCategories,
        user: User,
        utils: Utils
    }
})

export default store;
  